// extracted by mini-css-extract-plugin
module.exports = {"widget":"style_widget__or1tj","title":"style_title__3HT8n","lock":"style_lock__3D7dm","close":"style_close__1SC7X"};